export default __webpack_public_path__ + "static/media/shareIcon.35ee2b7a.svg";